

    
<template>
  <!-- <v-row
    style="
      display: block;
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      z-index: 2000;
      margin-top: 0px;
    "
  > 
  <v-card class="overflow-hidden">-->
  <v-card>
    <v-app-bar scroll-threshold="500" fixed tile app elevation="4">
      
      <v-app-bar-nav-icon
        @click="mainMenuDrawer = !mainMenuDrawer"
      ></v-app-bar-nav-icon>
      
      <v-spacer></v-spacer>
      <v-app-bar-title> {{ currentUser.username }}</v-app-bar-title>

      <v-btn icon @click="accountDrawer = !accountDrawer">
        <v-icon>mdi-account</v-icon>
      </v-btn>
        
    </v-app-bar>
  
    <v-navigation-drawer v-model="mainMenuDrawer" fixed left clipped app>
      <v-list nav dense flat @select="MainMenu_ItemSelected">
        <v-list-item-group active-class="blue--text text--darken-4">
          <span v-for="page in pages" :key="page.text">
            <v-list-item-title v-if="page.to == null">
              <v-icon v-if="page.icon != ''">{{ page.icon }}</v-icon>
              {{ page.text }}</v-list-item-title
            >

            <v-list-item v-if="page.to != null" :to="page.to">
              <v-list-item-title>
                <v-icon v-if="page.icon != ''">{{ page.icon }}</v-icon>
                {{ page.text }}</v-list-item-title
              >
            </v-list-item>
          </span>
          <!-- <v-list-item>
              <v-list-item-title ><v-icon>mdi-calendar</v-icon>  Pianifica interventi</v-list-item-title>
            </v-list-item>
  
            <v-list-item>
              <v-list-item-title><v-icon>mdi-tools</v-icon> Pianifica attrezzature</v-list-item-title>
            </v-list-item>
  
            <v-list-item>
              <v-list-item-title><v-icon>mdi-car</v-icon>Pianifica mezzi</v-list-item-title>
            </v-list-item>
  
            <v-list-item>
              <v-list-item-title>Buzz</v-list-item-title>
            </v-list-item> -->
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>
    <v-navigation-drawer v-model="accountDrawer" fixed right clipped temporary>
      <v-list nav dense>
        <v-list-item-group
          v-model="page"
          active-class="blue--text text--darken-4"
        >
          <v-list-item
            :to="{
              name: 'user-profile',
              params: {
                companyAlias: $route.params.companyAlias,
                hashId: currentUser.hashId,
              },
            }"
          >
            <v-list-item-title
              ><v-icon>mdi-account</v-icon>Informazioni
              personali</v-list-item-title
            >
          </v-list-item>

          <v-list-item :to="{ name: 'agenda-viewer' }">
            <v-list-item-title
              ><v-icon>mdi-calendar-text</v-icon> Agenda</v-list-item-title
            >
          </v-list-item>
          <v-list-item
            @click="SessionHelper.Logoff($route.params.companyAlias)"
          >
            <v-list-item-title
              ><v-icon>mdi-logout</v-icon> Esci</v-list-item-title
            >
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>
  </v-card>
  <!-- <v-app-bar
      fixed
      color="#43a047"
      dark
      shrink-on-scroll
      prominent
      src="https://picsum.photos/1920/1080?random"
      fade-img-on-scroll
      scroll-target="#scrolling-techniques-5"
      scroll-threshold="500"
    >
      <template v-slot:img="{ props }">
        <v-img
          v-bind="props"
          gradient="to top right, rgba(55,236,186,.7), rgba(25,32,72,.7)"
        ></v-img>
      </template>

      <v-app-bar-nav-icon></v-app-bar-nav-icon>

      <v-app-bar-title>{{this.companyInfo.ragioneSociale }}</v-app-bar-title>

      <v-spacer></v-spacer>

      
      <v-btn icon>
        <v-icon>mdi-dots-vertical</v-icon>
      </v-btn>
    </v-app-bar> -->
  <!-- <v-sheet
      id="scrolling-techniques-5"
      class="overflow-y-auto"
      max-height="600"
    >
      <v-container style="height: 1500px;"></v-container>
    </v-sheet>
  </v-card> -->
  <!-- <v-card>
      <v-card-title id="menu" class="blue white--text">
        <v-row>
          <v-col cols="9">
            <span class="headline">{{ this.companyInfo.ragioneSociale }}</span>
          </v-col>
          <v-col cols="3">
            <v-spacer></v-spacer>

            <v-menu bottom left>
              <template v-slot:activator="{ on, attrs }">
                <v-btn dark icon v-bind="attrs" v-on="on">
                  <h3
                    class="font-weight-medium white--text text-right"
                    style="text-transform: capitalize"
                  >
                    <v-avatar
                      v-bind:color="
                        currentUser.colore != null ? currentUser.colore : '#777'
                      "
                      size="40"
                    >
                      <v-icon>mdi-account-circle</v-icon>
                    </v-avatar>
                    <span class="d-none d-sm-inline">
                      &nbsp;
                      {{ currentUser.username }}
                    </span>
                    <v-icon
                      v-bind:color="
                        currentUser.colore != null ? currentUser.colore : '#777'
                      "
                    >
                      mdi-menu-down
                    </v-icon>
                  </h3>
                </v-btn>
              </template>

              <v-list>
                <v-list-item-group v-model="selectedItem">
                  <v-list-item
                    :key="item.value"
                    :value="item.value"
                    v-for="item in items"
                  >
                    <v-list-item-icon
                      ><v-icon>{{ item.icon }}</v-icon></v-list-item-icon
                    >
                    <v-list-item-content>
                      <v-list-item-title>{{ item.text }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-menu>
          </v-col>
        </v-row>
      </v-card-title>
    </v-card> -->
  <!-- </v-row> -->
</template>


 <style  >
/* #menu {
  padding-left: 30px;
  padding-right: 20px;
} */
</style> 
<script> 
import SessionHelper from "../../utils/SessionHelper";
export default {
  data: () => ({
    _currentUser: null,
    accountDrawer: false,
    mainMenuDrawer: false,
    hasSubheaderSlot:false,
    SessionHelper: SessionHelper,
    page: null,
    pages: [
      { text: "Dashboard", icon: "mdi-home", to: { name: "dashboard" } },
      { text: "Pianificazione", icon: "", to: null },
      {
        text: "Pianifica interventi",
        icon: "mdi-calendar",
        to: { name: "plan" },
      },
      {
        text: "Pianifica attrezzature",
        icon: "mdi-tools",
        to: { name: "plan-equipments" },
      },
      {
        text: "Pianifica mezzi",
        icon: "mdi-car",
        to: { name: "plan-vehicles" },
      },
      { text: "Strumenti amministrativi", icon: "", to: null },
      {
        text: "Gestione permessi",
        icon: "mdi-account-key",
        to: { name: "manage-roles" },
      },
      {
        text: "Gestione risorse",
        icon: "mdi-truck",
        to: { name: "manage-workers" },
      },
      {
        text: "Gestione clienti",
        icon: "mdi-account-multiple",
        to: { name: "manage-customers" },
      },
    ],
    items: [
      {
        text: "Informazioni personali",
        icon: "mdi-account-circle",
        value: "personalInfo",
      },
      {
        text: "Agenda",
        icon: "mdi-calendar",
        value: "mieiInterventi",
      },
      {
        text: "Esci",
        icon: "mdi-logout-variant",
        value: "logout",
      },
    ],
  }),
  created() {},
  methods: {
    MainMenu_ItemSelected(old, item) {
      this.mainMenuDrawer = false;
      console.debug("selected", item);
    },
    CurrentUserChanged(user) {
      this.currentUser = user;
    },
  },
  mounted(){

      console.debug("hassubheader",this.$slots)
      this.hasSubheaderSlot=!!this.$slots.subheader;
  },
  computed: { 
    selectedItem: {
      get() {
        return null;
      },
      set(val) {
        console.debug(val);
        switch (val) {
          case "logout":
            SessionHelper.Logoff(this.$route.params.companyAlias);
            break;
          case "mieiInterventi":
            this.$router.push({ name: "agenda-viewer" });
            break;
        }
      },
    },
    companyInfo() {
      if (localStorage.companyInfo != null)
        return JSON.parse(localStorage.companyInfo);
      else return { ragioneSociale: "---" };
    },
    currentUser: {
      get: function () {
        if (this._currentUser == null) {
          if (localStorage.currentUser != null)
            return JSON.parse(localStorage.currentUser);
          else return { username: "---" };
        } else return this._currentUser;
      },

      set: function (value) {
        this._currentUser = value;
      },
    },
  },
};
</script>

